import { ACTION_TYPES } from '../constants';

export default baseLink => ({
  type: ACTION_TYPES.SET_BASE_LINK,
  payload: {
    baseLink
  }
});
